












import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component({
    filters: {
        formatDate: (value: string) => {
            return (value !== undefined) ? moment(value).format('L') : 'NC';
        },
    },
})
export default class Timeline extends Vue {
    @Prop() dates!: {
        name: string;
        date: string;
    }[];

    get current() {
        for (let i = 0; i < this.dates.length; i++) {
            if (this.dates[i].date) {
                let date = this.dates[i].date;
                let dateNext = this.dates[i + 1]
                    ? this.dates[i + 1].date || null
                    : null;

                if (this.validate(date, dateNext)) {
                    return this.dates[i];
                }
            }
        }

        return null;
    }

    validate(date: string, dateNext: string | null): boolean {
        const newDate = new Date(date);
        const newDateNext = dateNext ? new Date(dateNext) : null;
        const now = new Date();
        return (
            now >= newDate &&
            (newDateNext === null || (newDateNext && now < newDateNext))
        );
    }
}
